import React from "react";
import {  post} from "../fetchData";

const useFetchSearch = ({ query }:{ query: string }) => {
  const [products, setSearch] = React.useState<any>([]);
  const [loading, setLoading] = React.useState(false);
  const [loaded, setLoaded] = React.useState(false);

  React.useEffect(() => {
    listSearch();
  }, []);

  const listSearch = () => {
    setLoading(true);
    setLoaded(false);
post({q:query},"search_product")
      .then(
        (result) => {
          setLoading(false);
          console.log("hooks::",result);
            setSearch(result.status ? result.data : []);
        },
        (error) => {
          setSearch([]);
        }
      )
      .finally(() => {
        setLoading(false);
        setLoaded(false);
      }); //fetch
  }; //doAjax

  return {products,loading,loaded};
};

export default useFetchSearch;
